import { useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { Box } from 'rebass/styled-components'
import styled from 'styled-components'
import Loading from '../../components/Loading'
import { SEARCH_PRODUCTS } from '../../graphql/queries'
import { Input } from '../Login/index'
import Header from '../../components/Header'
import ProductListItem from '../../components/ProductListItem'

import { IonPage, IonLoading, IonSearchbar, IonInput, IonButton } from '@ionic/react'
import IonContent from '../../components/IonContent'

const Search = styled(Input)``

const PList = ({ query }) => {
    const { data, loading } = useQuery(SEARCH_PRODUCTS, {
        variables: {
            query,
        },
    })
    return (
        <Box
            css={{
                height: 'calc(100vh - 60px)',
                overflowY: 'auto',
            }}
            pb="50px"
            pt="10px"
        >
            {data?.products?.edges?.map(item => (
                <ProductListItem node={item.node} key={item.node} />
            ))}
            {/* <ProductList products={data?.products?.edges}></ProductList> */}
            <IonLoading isOpen={loading}></IonLoading>
        </Box>
    )
}

export default () => {
    const [query, setQuery] = useState('')
    const [search, setSearch] = useState('')
    const handleKeyUp = e => {
        // if (e.keyCode === 13) {
        //     setQuery(search)
        // }
        e.preventDefault()

        setQuery(search)
    }

    return (
        <IonPage
            height="100vh"
            py="0"
            css={{
                overflowY: 'hidden',
            }}
        >
            <Header title="Search"></Header>
            <IonContent>
                <form onSubmit={handleKeyUp}>
                    <IonSearchbar
                        placeholder="Search Favorites"
                        value={search}
                        showCancelButton="focus"
                        // enterkeyhint="enter"
                        // onInput={handleKeyUp}
                        onIonChange={e => setSearch(e.detail.value)}
                    />
                </form>

                <Box px="20px">{query && <PList query={query}></PList>}</Box>
            </IonContent>
        </IonPage>
    )
}
